import { App } from 'vue'
import { logger } from '@/instance'

export default {
  install (app: App, opt: any) {
    app.directive('scrub', {
      /**
       * 模拟拖拽
       *
       * @param {*} el
       * @param {*} binding
       */
      mounted (el: HTMLElement, binding) {
        const callback = binding.value
        const modifiers = binding.modifiers
        logger.log('plugins/scrub', 'scrub mounted', arguments)
        const mousemove = (e: MouseEvent) => {
          const rect = el.getBoundingClientRect()
          callback({
            x: e.x - rect.x,
            y: e.y - rect.y,
            finished: false,
          })
        }
        const mouseup = (e: MouseEvent) => {
          const rect = el.getBoundingClientRect()
          callback({
            x: e.x - rect.x,
            y: e.y - rect.y,
            finished: true,
          })
          window.removeEventListener('mousemove', mousemove)
          window.removeEventListener('mouseup', mouseup)
        }
        el.onmousedown = (e: MouseEvent) => {
          modifiers.stop && e.stopPropagation()
          e.preventDefault()
          const rect = el.getBoundingClientRect()
          callback({
            x: e.x - rect.x,
            y: e.y - rect.y,
            finished: false,
          })
          window.addEventListener('mousemove', mousemove)
          window.addEventListener('mouseup', mouseup)
        }

        const touchmove = (e: TouchEvent) => {
          if (e.touches.length) {
            const ex = e.touches[0].clientX
            const ey = e.touches[0].clientY
            const rect = el.getBoundingClientRect()
            callback({
              x: ex - rect.x,
              y: ey - rect.y,
              finished: false,
            })
          }
        }
        const touchend = (e: TouchEvent) => {
          if (e.touches.length) {
            const ex = e.touches[0].clientX
            const ey = e.touches[0].clientY
            const rect = el.getBoundingClientRect()
            callback({
              x: ex - rect.x,
              y: ey - rect.y,
              finished: true,
            })
          } 
          window.removeEventListener('touchmove', touchmove)
          window.removeEventListener('touchend', touchend)
        }
        el.ontouchstart = (e: TouchEvent) => {
          modifiers.stop && e.stopPropagation()
          e.preventDefault()
          const rect = el.getBoundingClientRect()
          let x = e.touches[0].clientX
          let y = e.touches[0].clientY
          callback({
            x: x - rect.x,
            y: y - rect.y,
            finished: false,
          })
          window.addEventListener('touchmove', touchmove)
          window.addEventListener('touchend', touchend)
        }
        //
      },
      beforeUnmount (el: any) {
        logger.log('plugins/scrub', 'scrub before unmounted', arguments)
        el.onmousedown = null
        el.ontouchstart = null
      },
    })
  },
}
